import { useState, useEffect } from "react";
import { Country } from "@shared/interfaces/Country";
import { useProject } from "@utils/useProject";

const useFetchCountries = () => {
  const [isCountriesDataLoading, setIsCountriesDataLoading] = useState(true);
  const [countries, setCountries] = useState<Country[]>([]);
  const { getCountries } = useProject();

  useEffect(() => {
    if (countries.length > 0) return; // Prevents multiple fetches

    let retryTimeout: NodeJS.Timeout;

    const fetchCountries = async () => {
      try {
        const data = await getCountries();
        if (data) {
          setCountries(data);
          setIsCountriesDataLoading(false); // ✅ Stop loading only after success
        } else {
          retryTimeout = setTimeout(fetchCountries, 200); // Retry
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        retryTimeout = setTimeout(fetchCountries, 200); // Retry
      }
    };

    setIsCountriesDataLoading(true); // ✅ Start loading before first attempt
    fetchCountries();

    return () => clearTimeout(retryTimeout); // Cleanup
  }, []);

  return {
    countries,
    isCountriesDataLoading,
  };
};

export default useFetchCountries;
